import React from "react";
const ChartCard = ({ title, children }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
    {title && (
      <h3 className="text-lg font-bold text-slate-800 mb-3">{title}</h3>
    )}
    {children}
  </div>
);

export default ChartCard;
